<template>
<div id="edit-purchasable-item">
  <h2>Edit Purchasable Item #{{ purchasableItemId }}</h2>

  <purchasable-item-form
    :purchasableItemId="purchasableItemId"
  ></purchasable-item-form>
</div>
</template>

<script>
import PurchasableItemForm from '@/components/PurchasableItemForm'

import PurchasableItemStore from '@/stores/PurchasableItemStore'

export default {
  data () {
    return PurchasableItemStore.state
  },

  props: ['purchasableItemId'],

  components: {
    'purchasable-item-form': PurchasableItemForm
  },

  created () {
    this.get()
  },

  methods: {
    get () {
      this.apiGet('/purchasable_items/' + this.purchasableItemId, PurchasableItemStore, true)
    }
  },

  watch: {
    '$route' (to, from) {
      this.get()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchasableItemEdit.vue